(() => {
  const rootPath = () => window.Shopify?.routes?.root || '/';

  const initializeCollection = (section) => {
    if (section.dataset.wesleysInitialized === 'true') return;
    section.dataset.wesleysInitialized = 'true';

    section.querySelectorAll('[data-wesleys-variant-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const card = select.closest('[data-wesleys-product-card]');
        const option = select.options[select.selectedIndex];
        const price = card?.querySelector('[data-wesleys-price]');
        const comparePrice = card?.querySelector('[data-wesleys-compare-price]');
        const button = card?.querySelector('[data-wesleys-add-button]');
        const buttonLabel = card?.querySelector('[data-wesleys-add-label]');
        const status = card?.querySelector('[data-wesleys-add-status]');
        const isAvailable = option?.dataset.available === 'true';

        if (price) price.textContent = option?.dataset.price || '';

        if (comparePrice) {
          comparePrice.textContent = option?.dataset.comparePrice || '';
          comparePrice.hidden = !option?.dataset.comparePrice;
        }

        if (button) button.disabled = !isAvailable;

        if (buttonLabel) {
          buttonLabel.textContent = isAvailable
            ? 'Add to Cart'
            : 'Currently Unavailable';
        }

        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }
      });
    });

    section.querySelectorAll('.wesleys-card__form').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('[data-wesleys-add-button]');
        const label = form.querySelector('[data-wesleys-add-label]');
        const status = form.querySelector('[data-wesleys-add-status]');
        const variantInput = form.querySelector('[name="id"]');
        const quantityInput = form.querySelector('[name="quantity"]');

        if (!button || button.disabled) return;

        const variantId = variantInput ? String(variantInput.value) : '';
        const quantity = quantityInput
          ? Math.max(1, Number.parseInt(quantityInput.value, 10) || 1)
          : 1;

        if (!variantId) {
          if (status) {
            status.textContent = 'Please choose an option.';
            status.classList.add('is-error');
          }
          return;
        }

        button.disabled = true;
        if (label) label.textContent = 'Adding…';

        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }

        try {
          if (
            !window.Shopify ||
            !window.Shopify.actions ||
            typeof window.Shopify.actions.updateCart !== 'function'
          ) {
            throw new Error(
              'The Shopify cart is still loading. Please try again.'
            );
          }

          const result = await window.Shopify.actions.updateCart({
            lines: [
              {
                merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
                quantity
              }
            ]
          });

          if (
            result &&
            Array.isArray(result.userErrors) &&
            result.userErrors.length > 0
          ) {
            throw new Error(
              result.userErrors[0].message ||
                'This item could not be added.'
            );
          }

          if (label) label.textContent = 'Added!';

          if (status) {
            status.innerHTML =
              `Added to your cart. <a href="${rootPath()}cart">View cart</a>`;
          }

          window.setTimeout(() => {
            if (label) label.textContent = 'Add to Cart';
            button.disabled = false;
          }, 1500);
        } catch (error) {
          if (status) {
            status.textContent =
              error?.message ||
              'This item could not be added. Please try again.';
            status.classList.add('is-error');
          }

          if (label) label.textContent = 'Add to Cart';
          button.disabled = false;
        }
      });
    });

    const sort = section.querySelector('[data-wesleys-sort]');

    if (sort) {
      sort.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  };

  const initializeAll = () => {
    document
      .querySelectorAll('[data-wesleys-collection]')
      .forEach(initializeCollection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
